import {
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_FAILED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_FAILED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_CANCELED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_FAILED,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_SET,
    REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_MERGE,
    REPORTS_HARVEST_INSPECTION_SET
} from './constants';

export function requestloadReportsHarvestInspectionsAllMerged() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_REQUESTED
    };
}

export function succeededLoadReportsHarvestInspectionsAllMerged(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadReportsHarvestInspectionsAllMerged(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestPollingReportsHarvestInspectionsAllMerged() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_REQUESTED
    };
}

export function succeededPollingReportsHarvestInspectionsAllMerged(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_SUCCEEDED,
        payload: response
    };
}

export function failedPollingReportsHarvestInspectionsAllMerged(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_FAILED,
        payload: error,
        error: true
    };
}

export function canceledPollingReportsHarvestInspectionsAllMerged() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_POLLING_CANCELED
    };
}

export function requestExportReportsHarvestInspectionsAllMerged() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_REQUESTED
    };
}

export function succeededExportReportsHarvestInspectionsAllMerged(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_SUCCEEDED,
        payload: response
    };
}

export function failedExportReportsHarvestInspectionsAllMerged(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_EXPORT_FAILED,
        payload: error,
        error: true
    };
}

export function setReportsHarvestInspectionsAllMerged(
    data: Record<string, any>[]
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_SET,
        payload: data,
        meta: {
            // TODO create meaningful composite key
            keyBy: 'todo'
        }
    };
}

export function mergeReportsHarvestInspectionsAllMerged(
    data: Record<string, any>[]
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_ALL_MERGED_MERGE,
        payload: data
    };
}

export function setReportsHarvestInspection(data: Record<string, any>) {
    return {
        type: REPORTS_HARVEST_INSPECTION_SET,
        payload: data
    };
}
